<template>
  <v-app class="app">
    <v-main>
      <router-view></router-view>
    </v-main>
    <Snackbar />
    <span id="idoniaViewerLoadedFlag" style="width: 0; height: 0;"></span>
  </v-app>
</template>

<script>
import Vue from 'vue'
import { getParameterByName } from '@/utils'
import Snackbar from '@/components/Snackbar'
import { useConfig } from "@/config";

export default {
  name: 'App',
  components: { Snackbar },
  created () {
    const { set } = useConfig(this.$config)
    this.$root.$on('config-updated', (data) => {
      set('gaTrackingCode', data.gaTrackingCode)
      set('gtmCode', data.gtmCode)
    })
    window.addEventListener('message',(message)=>{
      switch (message.data.type) {
        case 'idonia-update-locale':
          this.$i18n.locale = message.data.data
          break
      }
    })
    Vue.axios.defaults.baseURL = this.$config.apiUrl
    Vue.axios.defaults.headers.Authorization = this.token
      ? `IDONIA token="${this.token}",account_id="${this.accountID}",socket_id=""`
      : `Bearer ${this.idToken}`
    Vue.prototype.$auth = this.token ? {token: this.token, accountID: this.accountID} : {idToken: this.idToken}
    if (this.lang) {
      this.$i18n.locale = this.lang
    } else {
      window.parent.postMessage({ type: 'idonia-get-locale' }, '*')
    }
    this.$config.downloadAllowed = this.$route.query.allow_download ?
      this.downloadAllowed : this.$config.downloadAllowed
  },
  destroyed() {
    this.$root.$off('config-updated')
  },
  computed: {
    token () {
      return this.$route.query.token
    },
    idToken () {
      return getParameterByName('id_token')
    },
    accountID () {
      return this.$route.query.account_id
    },
    lang () {
      return this.$route.query.lang
    },
    downloadAllowed () {
      return this.$route.query.allow_download==='true'
    }
  },
  watch: {
    lang (newLang) {
      this.$i18n.locale = newLang || this.$i18n.locale
    },
    downloadAllowed (newValue) {
      this.$config.downloadAllowed = newValue
    }
  }
}
</script>
<style>
.app{
  overflow: hidden;
}
</style>
